import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCatalogue } from "../../../hooks/useCatalogue";

const LEVELS = [200, 300, 400, 500, 600];

function Department() {
  const navigate = useNavigate();
  const { code, session } = useParams();
  const { courses, departments, loading } = useCatalogue();

  const dept = departments.find((d) => d.code === code);

  const getCourses = (level, semester) =>
    courses.filter(
      (c) =>
        c.type === "professional" &&
        c.level === level &&
        c.semester === semester &&
        c.department?.code === code
    );

  if (loading) return <div className="fc_page"><p className="fc_loading">Loading...</p></div>;

  return (
    <div className="fc_page">
      <div className="fc_header">
        <div>
          <p className="fc_overline">{session}</p>
          <h2>{dept?.name || code}</h2>
          <p className="fc_subtitle">Select a course to view or enter results.</p>
        </div>
      </div>

      <div className="fc_dept_body">
        {[1, 2].map((sem) => (
          <div key={sem} className="fc_sem_col">
            <p className="fc_section_label">{sem === 1 ? "First" : "Second"} Semester</p>
            {LEVELS.map((level) => {
              const list = getCourses(level, sem);
              if (!list.length) return null;
              return (
                <div key={level} className="fc_level_group">
                  <p className="fc_level_label">{level} Level</p>
                  <div className="fc_course_list">
                    {list.map((c) => (
                      <button
                        key={c.code}
                        className="fc_course_btn"
                        onClick={() => navigate(`/admin/faculty/${session}/${level}/${sem}/${c.code}`)}
                      >
                        <span className="fc_course_code">{c.code.toUpperCase()}</span>
                        <span className="fc_course_title">{c.title}</span>
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Department;
